import { render, staticRenderFns } from "./JobTask.vue?vue&type=template&id=65a8cca7&scoped=true&"
import script from "./JobTask.vue?vue&type=script&lang=js&"
export * from "./JobTask.vue?vue&type=script&lang=js&"
import style0 from "./JobTask.vue?vue&type=style&index=0&id=65a8cca7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a8cca7",
  null
  
)

export default component.exports